import '../Footnote/Footnote.css';
import GatisheelFooterLogo from '../images/gatisheel_logo.png';
import {Link } from 'react-router-dom'

export default function Footnote()
{
  return(
  <>
    <footer className="siteFooter">
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                    <div className="col-left">
                        <div className="brand-brief">
                            <a className="footer-logo" href="<?php echo site_url(); ?>">
                            <img src={GatisheelFooterLogo} style={{ width: "60px", height: "60px" }} alt=" " />
                            </a>
                            <p className="pt-3">
                            IOT company and data powerhouse for Agriculture sector <br></br>
                                - Crop wise water usage pattern<br></br>
                                - Pump usage, control and health monitoriing<br></br>
                                - Virtual water, Energy & Water conservation

                            </p>
                        </div>
                        <div className="d-none d-sm-block d-sm-none d-md-block">
                            <div className="social-links">
                                <div className="socialIcon">
                                    <a rel="noopener noreferrer nofollow" href="/" target="_blank"><span><i className="fa-brands fa-facebook-f fa-2x"></i></span></a>
                                </div>
                                <div className="socialIcon">
                                    <a rel="noopener noreferrer nofollow" href="/" target="_blank"><span><i className="fa-brands fa-instagram fa-2x"></i></span></a>
                                </div>
                                <div className="socialIcon">
                                    <a rel="noopener noreferrer nofollow" href="https://www.linkedin.com/company/aggatisheel/?viewAsMember=true" target="_blank"><span><i class="fa-brands fa-linkedin fa-2x"></i></span></a>
                                </div>
                                <div className="socialIcon">
                                    <a rel="noopener noreferrer nofollow" href="https://www.youtube.com/channel/UCKVeUl5N8c-g-yEDs2eORSg" target="_blank"><span><i class="fa-brands fa-youtube fa-2x"></i></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                    <div className="colFooterNav">
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-6 mb-5">
                                <h3>QUICK LINKS</h3>
                                <ul className='footerNav'>
                                    <li><a href="/"><Link to='/'><button className='btn'>Home</button></Link></a></li>
                                    <li><a href="/" ><Link to='/aboutus'><button className='btn'>About</button></Link></a></li>
                                    <li><a href="/"><Link to='/contactus'><button className='btn'>Contact</button></Link></a></li>
                                </ul>
                            </div>

                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-6 mb-5">
                                <h3>OTHER LINKS</h3>
                                <ul className='footerNav'>
                                    <li><a href="/"><Link to='/'><button className='btn'>Privacy Policy</button></Link></a></li>
                                    <li><a href="/"><Link to='/'><button className='btn'>Terms of Use</button></Link></a></li>
                                    <li><a href="/"><Link to='/'><button className='btn'>Disclaimer</button></Link></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="copyright">
            <div className="col-12 text-center py-4">
            &copy; 2023 Gatisheel, All rights reserved.
            </div>
        </div>
    </footer>
  </> 
  )
};